exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/deep/ .el-image {\n  line-height: 100%;\n  text-align: center;\n}\n.image-slot {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  height: 100%;\n  background: #f5f7fa;\n  color: #bbbfc8;\n}\n.image-icon {\n  font-size: 50px;\n  line-height: 50px;\n  height: 50px;\n  width: 50px;\n}\n", ""]);

// exports
